export default "__VITE_ASSET__UsrU_eQL__"